(function () {
  function loadSwiper(callback) {
    if (window.Swiper) {
      callback();
      return;
    }

    var existing = document.querySelector("script[data-dodo-swiper]");
    if (existing) {
      existing.addEventListener("load", callback, { once: true });
      return;
    }

    var script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
    script.defer = true;
    script.dataset.dodoSwiper = "true";
    script.onload = callback;
    document.head.appendChild(script);
  }

  function sectionOf(element) {
    return element.closest(".shopify-section") || element.parentElement;
  }

  function initSliders(selector, configFactory) {
    var elements = document.querySelectorAll(selector);
    if (!elements.length) {
      return;
    }

    elements.forEach(function (element) {
      if (element.swiper && !element.swiper.destroyed) {
        return;
      }

      if (element.dataset.swiperReady === "true") {
        return;
      }

      try {
        var section = sectionOf(element);
        new window.Swiper(element, configFactory(section));
        element.dataset.swiperReady = "true";
      } catch (error) {
        element.dataset.swiperReady = "false";
        if (window.console && typeof window.console.error === "function") {
          window.console.error("Failed to initialize swiper for selector:", selector, error);
        }
      }
    });
  }

  function resetSwiperStyles(swiper) {
    if (!swiper) {
      return;
    }

    if (swiper.wrapperEl) {
      swiper.wrapperEl.style.transform = "";
      swiper.wrapperEl.style.transitionDuration = "";
      swiper.wrapperEl.style.transitionProperty = "";
      swiper.wrapperEl.style.transitionTimingFunction = "";
      swiper.wrapperEl.style.width = "";
    }

    if (swiper.slides && swiper.slides.length) {
      swiper.slides.forEach(function (slide) {
        slide.style.width = "";
        slide.style.marginRight = "";
        slide.style.transform = "";
      });
    }
  }

  function mobileCardConfig(wrapperClass, slideClass) {
    function syncState(swiper) {
      var isMobile = window.matchMedia("(max-width: 749px)").matches;
      swiper.el.classList.toggle("is-mobile-card-swiper", isMobile);
      if (!isMobile) {
        resetSwiperStyles(swiper);
      }
    }

    return {
      wrapperClass: wrapperClass,
      slideClass: slideClass,
      slidesPerView: 1.2,
      spaceBetween: 12,
      speed: 420,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        460: { slidesPerView: 1.28, spaceBetween: 12 },
        640: { slidesPerView: 1.45, spaceBetween: 14 },
        750: { slidesPerView: 3, spaceBetween: 16, allowTouchMove: false, grabCursor: false },
        1024: { slidesPerView: 3, spaceBetween: 20, allowTouchMove: false, grabCursor: false },
        1280: { slidesPerView: 3, spaceBetween: 20, allowTouchMove: false, grabCursor: false }
      },
      on: {
        init: syncState,
        breakpoint: syncState,
        resize: syncState,
        destroy: function (swiper) {
          if (swiper && swiper.el) {
            swiper.el.classList.remove("is-mobile-card-swiper");
          }
        }
      }
    };
  }

  function initScienceSections() {
    var sections = document.querySelectorAll("[data-science-section]");
    if (!sections.length) {
      return;
    }

    sections.forEach(function (section) {
      if (section.dataset.scienceReady === "true") {
        return;
      }

      var stage = section.querySelector("[data-science-stage]");
      var triggers = Array.prototype.slice.call(section.querySelectorAll("[data-science-trigger]"));
      var panels = Array.prototype.slice.call(section.querySelectorAll("[data-science-panel]"));
      var desktopMedia = window.matchMedia("(hover: hover) and (pointer: fine)");

      if (!stage || !triggers.length) {
        section.dataset.scienceReady = "true";
        return;
      }

      function updateMobileCalloutPlacement(index) {
        if (desktopMedia.matches) {
          panels.forEach(function (panel) {
            panel.classList.remove("is-mobile-left", "is-mobile-right");
            panel.style.removeProperty("--dodo-science-mobile-panel-width");
            panel.style.removeProperty("--dodo-science-mobile-overlap");
          });
          return;
        }

        panels.forEach(function (panel) {
          panel.classList.remove("is-mobile-left", "is-mobile-right");
          panel.style.removeProperty("--dodo-science-mobile-panel-width");
          panel.style.removeProperty("--dodo-science-mobile-overlap");
        });

        if (index === null || index === undefined) {
          return;
        }

        var activeTrigger = triggers.find(function (trigger) {
          return String(index) === trigger.dataset.scienceIndex;
        });
        var activePanel = panels.find(function (panel) {
          return String(index) === panel.dataset.scienceIndex;
        });

        if (!activeTrigger || !activePanel) {
          return;
        }

        var stageRect = stage.getBoundingClientRect();
        var triggerRect = activeTrigger.getBoundingClientRect();
        var leftSpace = triggerRect.left - stageRect.left;
        var rightSpace = stageRect.right - triggerRect.right;
        var preferredSide = activePanel.dataset.scienceSide === "left" ? "left" : "right";
        var maxPanelWidth = Math.min(stageRect.width * 0.62, 252);
        var overlapAllowance = 26;
        var rightWidth = Math.max(124, Math.min(maxPanelWidth, rightSpace + overlapAllowance));
        var leftWidth = Math.max(124, Math.min(maxPanelWidth, leftSpace + overlapAllowance));
        var safeInset = 10;

        if (preferredSide === "right") {
          var rightOverlap = Math.max(18, rightWidth - rightSpace + safeInset);
          activePanel.classList.add("is-mobile-right");
          activePanel.style.setProperty("--dodo-science-mobile-panel-width", rightWidth + "px");
          activePanel.style.setProperty("--dodo-science-mobile-overlap", rightOverlap + "px");
          return;
        }

        var leftOverlap = Math.max(18, leftWidth - leftSpace + safeInset);
        activePanel.classList.add("is-mobile-left");
        activePanel.style.setProperty("--dodo-science-mobile-panel-width", leftWidth + "px");
        activePanel.style.setProperty("--dodo-science-mobile-overlap", leftOverlap + "px");
      }

      function setActive(index) {
        var hasActive = index !== null && index !== undefined;

        stage.classList.toggle("has-active", hasActive);
        stage.classList.toggle("is-paused", hasActive);

        triggers.forEach(function (trigger) {
          var isActive = String(index) === trigger.dataset.scienceIndex;
          trigger.classList.toggle("is-active", isActive);
          trigger.setAttribute("aria-expanded", isActive ? "true" : "false");
          if (trigger.parentElement) {
            trigger.parentElement.classList.toggle("is-active", isActive);
          }
        });

        panels.forEach(function (panel) {
          var isActive = String(index) === panel.dataset.scienceIndex;
          panel.classList.toggle("is-active", isActive);
          panel.setAttribute("aria-hidden", isActive ? "false" : "true");
        });

        window.requestAnimationFrame(function () {
          updateMobileCalloutPlacement(index);
        });
      }

      triggers.forEach(function (trigger) {
        trigger.addEventListener("mouseenter", function () {
          if (!desktopMedia.matches) {
            return;
          }
          setActive(trigger.dataset.scienceIndex);
        });

        trigger.addEventListener("mouseleave", function (event) {
          if (!desktopMedia.matches) {
            return;
          }

          var related = event.relatedTarget;
          if (related && section.contains(related)) {
            return;
          }

          setActive(null);
        });

        trigger.addEventListener("focus", function () {
          if (!desktopMedia.matches) {
            return;
          }
          setActive(trigger.dataset.scienceIndex);
        });

        trigger.addEventListener("click", function () {
          if (desktopMedia.matches) {
            setActive(trigger.dataset.scienceIndex);
            return;
          }

          if (trigger.classList.contains("is-active")) {
            setActive(null);
            return;
          }

          setActive(trigger.dataset.scienceIndex);
        });
      });

      section.addEventListener("mouseleave", function () {
        if (!desktopMedia.matches) {
          return;
        }
        setActive(null);
      });

      stage.addEventListener("mouseleave", function () {
        if (!desktopMedia.matches) {
          return;
        }
        setActive(null);
      });

      section.addEventListener("focusout", function (event) {
        if (!desktopMedia.matches) {
          return;
        }

        if (section.contains(event.relatedTarget)) {
          return;
        }
        setActive(null);
      });

      window.addEventListener("resize", function () {
        var activeTrigger = triggers.find(function (trigger) {
          return trigger.classList.contains("is-active");
        });
        updateMobileCalloutPlacement(activeTrigger ? activeTrigger.dataset.scienceIndex : null);
      });

      section.dataset.scienceReady = "true";
    });
  }

  function initAll() {
    if (!window.Swiper) {
      return;
    }

    initSliders(".dodo-home-hero-swiper", function (section) {
      var heroSwiper = section.querySelector(".dodo-home-hero-swiper");
      var shouldAutoplay = heroSwiper && heroSwiper.dataset.autoplay === "true";
      var heroSlides = heroSwiper ? heroSwiper.querySelectorAll(".swiper-slide").length : 0;
      var hasMultipleSlides = heroSlides > 1;
      var heroNav = section.querySelector(".dodo-home-hero-nav");
      var heroPagination = section.querySelector(".dodo-home-hero-pagination");

      // Read delay from Liquid data attribute; fall back to 7500 ms
      var autoplayDelay = heroSwiper && heroSwiper.dataset.autoplayDelay
        ? parseInt(heroSwiper.dataset.autoplayDelay, 10)
        : 7500;
      if (isNaN(autoplayDelay) || autoplayDelay < 1000) autoplayDelay = 7500;

      if (heroNav) {
        heroNav.style.display = hasMultipleSlides ? "" : "none";
      }

      // Build custom pagination dots (bypasses Swiper's pagination module
      // to avoid CSS specificity battles and overflow-clip interference).
      function buildHeroDots(swiper) {
        if (!heroPagination || !hasMultipleSlides) { return; }
        heroPagination.innerHTML = "";
        for (var i = 0; i < heroSlides; i++) {
          var dot = document.createElement("button");
          dot.type = "button";
          dot.className = "dodo-hero-dot" + (i === swiper.realIndex ? " is-active" : "");
          dot.setAttribute("aria-label", "Go to slide " + (i + 1));
          dot.setAttribute("role", "tab");
          dot.setAttribute("aria-selected", i === swiper.realIndex ? "true" : "false");
          (function (idx) {
            dot.addEventListener("click", function () {
              swiper.slideToLoop(idx);
            });
          })(i);
          heroPagination.appendChild(dot);
        }
      }

      function updateHeroDots(swiper) {
        if (!heroPagination) { return; }
        var dots = heroPagination.querySelectorAll(".dodo-hero-dot");
        var realIndex = swiper.realIndex;
        for (var d = 0; d < dots.length; d++) {
          var isActive = d === realIndex;
          dots[d].classList.toggle("is-active", isActive);
          dots[d].setAttribute("aria-selected", isActive ? "true" : "false");
        }
      }

      return {
        slidesPerView: 1,
        loop: hasMultipleSlides,
        autoHeight: true,
        spaceBetween: 14,
        autoplay: shouldAutoplay && hasMultipleSlides
          ? {
              delay: autoplayDelay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }
          : false,
        navigation: {
          prevEl: section.querySelector(".dodo-home-hero-prev"),
          nextEl: section.querySelector(".dodo-home-hero-next")
        },
        on: {
          afterInit: buildHeroDots,
          realIndexChange: updateHeroDots
        }
      };
    });

    initSliders(".dodo-home-utility-swiper", function (section) {
      return {
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: 12,
        speed: 420,
        grabCursor: true,
        navigation: {
          prevEl: section.querySelector(".dodo-home-utility-prev"),
          nextEl: section.querySelector(".dodo-home-utility-next")
        },
        pagination: {
          el: section.querySelector(".dodo-home-utility-pagination"),
          clickable: true
        },
        breakpoints: {
          560: { slidesPerView: 1.45, spaceBetween: 14 },
          768: { slidesPerView: 2, spaceBetween: 18 },
          1024: { slidesPerView: 3, spaceBetween: 22 },
          1360: { slidesPerView: 4, spaceBetween: 24 }
        },
        watchOverflow: true
      };
    });

    initSliders(".dodo-home-categories-swiper", function (section) {
      return {
        slidesPerView: 1.2,
        slidesPerGroup: 1,
        spaceBetween: 12,
        speed: 420,
        grabCursor: true,
        pagination: {
          el: section.querySelector(".dodo-home-categories-pagination"),
          clickable: true
        },
        breakpoints: {
          560: { slidesPerView: 1.55, spaceBetween: 14 },
          768: { slidesPerView: 2.25, spaceBetween: 18 },
          1024: { slidesPerView: 3.15, spaceBetween: 22 },
          1360: { slidesPerView: 4, spaceBetween: 24 }
        },
        watchOverflow: true
      };
    });

    initSliders(".dodo-home-best-swiper", function (section) {
      return {
        slidesPerView: 2,
        spaceBetween: 10,
        speed: 420,
        grabCursor: true,
        navigation: {
          prevEl: section.querySelector(".dodo-home-best-prev"),
          nextEl: section.querySelector(".dodo-home-best-next")
        },
        breakpoints: {
          560: { slidesPerView: 2.2, spaceBetween: 12 },
          768: { slidesPerView: 2.8, spaceBetween: 14 },
          980: { slidesPerView: 3, spaceBetween: 17 },
          1200: { slidesPerView: 4, spaceBetween: 18 }
        },
        watchOverflow: true
      };
    });

    initSliders(".dodo-home-loved-swiper", function (section) {
      return {
        slidesPerView: 2,
        spaceBetween: 10,
        speed: 420,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: section.querySelector(".dodo-home-loved-prev"),
          nextEl: section.querySelector(".dodo-home-loved-next")
        },
        breakpoints: {
          460: { slidesPerView: 2, spaceBetween: 10 },
          640: { slidesPerView: 2.5, spaceBetween: 12 },
          750: { slidesPerView: 3, spaceBetween: 16 },
          1024: { slidesPerView: 3, spaceBetween: 20 },
          1180: { slidesPerView: 4, spaceBetween: 20 }
        }
      };
    });

    initSliders(".dodo-home-family-shell", function (section) {
      return {
        wrapperClass: "dodo-home-family-grid",
        slideClass: "dodo-home-family-card",
        slidesPerView: 2,
        spaceBetween: 10,
        speed: 420,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: section.querySelector(".dodo-home-family-prev"),
          nextEl: section.querySelector(".dodo-home-family-next")
        },
        breakpoints: {
          460: { slidesPerView: 2, spaceBetween: 10 },
          640: { slidesPerView: 2.5, spaceBetween: 12 },
          750: { slidesPerView: 2, spaceBetween: 16 },
          1024: { slidesPerView: 3, spaceBetween: 20 },
          1280: { slidesPerView: 3, spaceBetween: 20 }
        }
      };
    });

    initSliders(".dodo-home-rec-swiper", function (section) {
      return {
        slidesPerView: 2,
        spaceBetween: 10,
        speed: 420,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          prevEl: section.querySelector(".dodo-home-rec-prev"),
          nextEl: section.querySelector(".dodo-home-rec-next")
        },
        breakpoints: {
          460: { slidesPerView: 2, spaceBetween: 10 },
          640: { slidesPerView: 2.5, spaceBetween: 12 },
          750: { slidesPerView: 3, spaceBetween: 16 },
          1024: { slidesPerView: 3, spaceBetween: 20 },
          1180: { slidesPerView: 3, spaceBetween: 20 }
        }
      };
    });

    initScienceSections();
  }

  function boot() {
    loadSwiper(initAll);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();
